"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Tz = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 72 48", ...props },
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "tz_svg__a" },
            react_1.default.createElement("path", { d: "M0 0h72v48H0z" }))),
    react_1.default.createElement("path", { fill: "#1eb53a", d: "M0 48V0h72z" }),
    react_1.default.createElement("path", { fill: "#00a3dd", d: "M72 0v48H0z" }),
    react_1.default.createElement("g", { fill: "none", clipPath: "url(#tz_svg__a)" },
        react_1.default.createElement("path", { stroke: "#fcd116", strokeWidth: 19, d: "M0 48 72 0" }),
        react_1.default.createElement("path", { stroke: "#000", strokeWidth: 13, d: "M0 48 72 0" }))));
exports.default = Tz;
//# sourceMappingURL=Tz.js.map